import { frontendURL } from 'dashboard/helper/URLHelper';
import ProfessionalsIndex from './pages/ProfessionalsIndex.vue';

const professionalsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/professionals'),
      name: 'professionals_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ProfessionalsIndex,
    },
  ],
};

export default professionalsRoutes;
